

















import { PropType, computed, defineComponent } from '@nuxtjs/composition-api';
import { SfImage } from '@storefront-ui/vue';
import HTMLContent from '~/components/HTMLContent.vue';

export default defineComponent({
  name: 'ProductExtraInfo',
  components: {
    HTMLContent,
    SfImage,
  },
  props: {
    product: {
      type: [Object, null] as PropType<any>,
      default: null,
    },
  },
  setup(props) {
    const productPackageBenefits = computed(() => props.product?.package_benefits?.html || '');
    const productHealthParameters = computed(() => props.product?.health_parameters_evaluated?.html || '');

    return {
      productPackageBenefits,
      productHealthParameters,
    };
  },
});
